import React from "react";
import { useTranslation } from "react-i18next";
import Stepper from "react-stepper-horizontal";

const Order = ({ order }) => {
  const { t } = useTranslation();

  return (
    <div className="order" data-aos="fade-up">
      <div className="d-flex">
        <div className="flex-fill">
          <div className="text-muted">
            <strong> {`${t("orderDate")} ${order.createdAt.toDate().toLocaleDateString()}`}</strong>
          </div>
          <div className="text-muted mt-1">
            <strong> {`${t("price")}: ${order.totalPrice} ${t("SAR")}`}</strong>
          </div>
        </div>
        <div>
          <div className="text-muted">
            <strong> {`${t("orderId")} ${order.id}`}</strong>
          </div>
          {order.deliveredAt && (
            <div className="text-muted">
              <strong> {`${t("deliveredAt")} ${order.deliveredAt.toDate().toLocaleDateString()}`}</strong>
            </div>
          )}
        </div>
      </div>

      <div dir="ltr">
        <Stepper
          steps={[{ title: t("prepared") }, { title: t("ready") }, { title: t("out") }, { title: t("delivered") }]}
          activeStep={order.status === 3 ? order.status + 1 : order.status}
          activeColor="green"
          size={20}
          circleFontSize={12}
          titleFontSize={12}
          circleTop={20}
        />
      </div>

      <div className="text-muted mt-3">
        <strong>
          {order.items.length} {t("items")}
        </strong>
      </div>

      <div className="more-items">
        {order.items.map((item, i) => (
          <div key={i} className="mx-2">
            <div className="border rounded p-1">
              <img src={item.image} alt={item.nameEn} height={50} width={50} />
            </div>

            <div className="text-muted text-center">
              <strong>{item.quantity}</strong>
              {item.type === "kilos" ? <span className="mx-2">KG</span> : null}
            </div>
          </div>
        ))}
      </div>

      <hr className="text-muted" />

      <div className="text-muted mt-3">
        <strong>{t("address")}</strong>
      </div>

      <div className="text-muted mt-3">{order.address}</div>
    </div>
  );
};

export default Order;
